import React from 'react';
import './index.scss';
import emailIcon from '../../assets/email.png';
import successIcon from '../../assets/v1.png';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';


export interface IInviteProps {
  logo:string,
  inviterId:string;
  trailId:string;
  qrcode:string;
  state:string
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId:string;
  qrcode:string;
  state:string
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  inviterId:string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class VankePage extends React.Component<IInviteProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId:'',
    qrcode:'',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({
        lang: 'en-US'
      });
    }
    let title = '';
    switch (path) {
      case 'trial/activity':
      case 'trial/activity-kw':
        title = 'iSlide VIP体验活动';
        break;
      case 'trial/bookActivity':
        title = 'iSlide 书籍活动';
        break;
      default:
        title = 'iSlide VIP体验活动';
        break;
    }
    this.setState({
      title
    });

    if (path === 'trial/activity-kw') {
      let custom = require('../../assets/kw.png');
      this.setState({
        custom
      });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId:this.props.trailId,
        logo: this.props.logo,
        inviterId:this.props.inviterId,
        qrcode:this.state.qrcode,
        state:this.props.state
      });
  }
  handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  async handleSubmit() {
    if (!this.state.email.trim()) {
      return this.setState({
        errMsg: '邮箱必填',
        showErr: true
      });
    }

    this.setState({
      disabled: true
    });

    let result: ITrialRes = await api.register(
      this.state.email.trim(),
      this.state.trailId,
      this.state.state,
      this.state.inviterId,
    );
    if (result.error) {
      return this.setState({
        disabled: false,
        errMsg: result.error,
        showErr: true
      });
    }
    if (result.body) {
      ReactGA.pageview(window.location.pathname+`/${result.body.days}days/email/success`);
      this.setState({
        time: `${result.body.days}`,
        showDialog: true
      });
    }
  }

  handleWechat = () => {
    if (!this.state.buttonUrl) {
      return;
    }
    // window.location.href = this.state.buttonUrl;
    window.open(this.state.buttonUrl);
  };

  render() {
    return (
      <div id="vanke-page">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        <section id="header">
          {/*{this.state.custom ? (*/}
          <div className="custom">
            {this.state.logo ?<p style={{background: 'url("https://static.islide.cc/web/img/ce8fd513d374490ae10dc08b3db107bb74d188c7.png") no-repeat bottom center',
              backgroundSize: '100% 1.5rem'}}> <img src={this.state.logo} alt=""/> <span>OFFICE 专属福利</span></p>: this.state.custom ?
              <p style={{background: 'url("https://static.islide.cc/web/img/ce8fd513d374490ae10dc08b3db107bb74d188c7.png") no-repeat bottom center',
                backgroundSize: '100% 1.5rem'}}><img src={this.state.custom} alt=""/><span>OFFICE 专属福利</span></p> : null}
          </div>
          {/*) : null}*/}
        </section>
        <section id="introduce">
          <div className="islide_intro">
            <h3>iSlide是什么</h3>
            <p>一款基于PPT的插件工具</p>
            <p>包含38个设计辅助功能，8大在线资源库</p>
            <p>让PPT设计变得简单起来！</p>
          </div>
          <div className="islide_device">
            <h3>支持版本</h3>
            <div className="islide_device_box">
              <div className="islide_windows">
                <div><img src="https://static.islide.cc/web/img/987587a8e73d50f64aea0649d0832f503fb43e65.png" alt=""/></div>
                <p>支持windows版</p>
                <p>PPT / WPS</p>
              </div>
              <div className="islide_mac">
                <div><img src="https://static.islide.cc/web/img/215880d7a5d4146bfc832b4d6fdb4e5c274f6300.png" alt=""/></div>
                <p>支持macOS版</p>
                <p>PPT</p>
              </div>
            </div>
          </div>
          <div className="islide_vip_right">
            <h3>领取VIP会员专享权益</h3>
            <div className="islide_right_intro">
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/07bd021f747ab4921cbfeebb5dc30d450181705e.png" alt=""/></div>
                <p>解锁VIP下载</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/292c6b06d48754b9178c38343f692cd91869368a.png" alt=""/></div>
                <p>原创模板设计</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/26baf04fb6b9001a0bcd11a0612fefe41ca61b21.png" alt=""/></div>
                <p>正版授权保障</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/de03a5b5cda3fe31c96e5778b802ddf013cf8f1c.png" alt=""/></div>
                <p>绿色安全下载</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/4a90f61bd83079a87843bffd81db57b04dd48977.png" alt=""/></div>
                <p>海量PPT素材</p>
              </div>
              <div className="islide_right_box">
                <div><img src="https://static.islide.cc/web/img/2bae12c9db677cc91686feeeb804b86da99a7f19.png" alt=""/></div>
                <p>资源持续更新</p>
              </div>
            </div>
          </div>

        </section>
        <section id="form">
          <div className="form">
            <p className="err-message">{this.state.errMsg}</p>
            <div className="form-input">
              <img className="email-icon" src={emailIcon} alt="email"/>
              <input
                onChange={this.handleEmailChange.bind(this)}
                placeholder="填写邮箱获取iSlide VIP会员"
              />
            </div>
            <button
              onClick={this.handleSubmit.bind(this)}
              disabled={this.state.disabled}
            >
              立即体验
            </button>
          </div>
          {this.state.qrcode?<div className="weChatShare">
            <img src={this.state.qrcode?this.state.qrcode:require('../../assets/wechatQrcode.jpg')} alt=""/>
            <p>关注公众号</p>
            <p>回复“万科”获取150套商务PPT模板</p>
          </div>:null}
        </section>
        <Dialog
          visible={this.state.showDialog}
          onClose={() => {
            this.setState({
              showDialog: false,
              disabled: false
            });
          }}
        >
          <div className="dialog-success">
            <img src={successIcon} alt="success"/>
            <p className="message">账号开通成功!</p>
            <section className="footer">
              <p className="remark">您的体验会员时长为{this.state.time}天，请及时登录使用</p>
              <p className="remark" style={{ marginTop: '0.2rem' }}>
                请查收以便于及时激活您的账号
              </p>
              <p className="remark" style={{ marginBottom: '0.4rem' }}>
                (可能误判为垃圾邮件)
              </p>
            </section>
          </div>
        </Dialog>
      </div>
      //{' '}
    );
  }
}
